<template>
  <div class="input-amo">
    <label class="input-label" v-if="label">{{label}}</label>
    <div class="input-block">
      <input
        :disabled="disabled"
        v-model="model"
        :class="['input-style', invalid && model != '' && 'invalid']"
        :type="showpassword && type == 'password' ? 'text' : type"
        :placeholder="placeholder"
      />
      <i
        v-if="type == 'password'"
        @click="showpassword = !showpassword"
        :class="`password-visibility mdi mdi-${showpassword ? 'eye-off': 'eye'}`"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Input',
  data () {
    return {
      showpassword: false
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: String,
    value: {
      type: String
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (event) {
        this.$emit('change', event)
      }
    }
  }
}
</script>

<style lang="scss">
@import "./style.scss";
</style>
